import React, { useState } from 'react';
import { LEVEL_META, LEVEL_ORDER, fmtK, fmtDate, Title, Panel, LevelBadge } from './bbShared';

const WEIGHTS = { brulant: 99, tres_chaud: 90, chaud: 75, tiede: 50, crame: 0 };

const TABS = [['semaine', 'Semaine'], ['mois', 'Mois'], ['trimestre', 'Trimestre']];

const LevelLine = ({ k, v }) => (
  <div className="flex items-center justify-between gap-3 py-2 border-t border-[#EEECE8] text-sm" data-testid={`bb-prev-level-${k}`}>
    <LevelBadge level={k} />
    <span className="text-slate-500">{v.count} dossier{v.count > 1 ? 's' : ''} · {fmtK(v.brut)}</span>
    <span className="ml-auto font-bold tabular-nums">{k === 'crame' ? '0 €' : fmtK(v.pondere)}</span>
  </div>
);

export const PrevisionPonderee = ({ prevision }) => {
  const [tab, setTab] = useState('trimestre');
  if (!prevision) return null;
  const w = prevision[tab];
  return (
    <Panel testId="bb-prevision">
      <div className="flex flex-wrap items-baseline justify-between gap-3 mb-4">
        <div>
          <Title className="text-xl">Prévision pondérée</Title>
          <p className="text-xs text-slate-500 mt-0.5">Run rate × probabilité du niveau, selon la date de signature estimée de la simulation · du {fmtDate(w.start)} au {fmtDate(w.end)}</p>
        </div>
        <div className="inline-flex rounded-full bg-[#F3F2EE] p-1" data-testid="bb-prev-tabs">
          {TABS.map(([k, l]) => (
            <button key={k} type="button" onClick={() => setTab(k)} data-testid={`bb-prev-tab-${k}`}
              className={`px-3 py-1 text-xs font-semibold rounded-full transition-colors ${tab === k ? 'bg-[#25272B] text-white' : 'text-slate-600 hover:text-slate-900'}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-[260px_1fr] gap-6">
        <div className="rounded-2xl bg-[#25272B] text-white p-5">
          <p className="text-sm sm:text-base uppercase tracking-[0.08em] text-[#F26A1B] font-bold">Run rate pondéré</p>
          <p className="text-4xl font-bold mt-1" style={{ fontFamily: 'var(--font-display)' }} data-testid="bb-prev-pondere">{fmtK(w.pondere)}</p>
          <p className="text-base text-white/85 mt-2">sur {fmtK(w.brut)} de run rate brut</p>
          <p className="text-sm mt-4"><b data-testid="bb-prev-signatures">{w.signatures_probables}</b> signature{w.signatures_probables > 1 ? 's' : ''} probable{w.signatures_probables > 1 ? 's' : ''} · {w.count} dossier{w.count > 1 ? 's' : ''}</p>
        </div>
        <div>
          {LEVEL_ORDER.map(k => <LevelLine key={k} k={k} v={w.levels[k]} />)}
          <p className="text-[11px] text-slate-500 mt-2">
            Pondération : {LEVEL_ORDER.map(k => `${LEVEL_META[k].label} ${WEIGHTS[k]} %`).join(' · ')}
            {prevision.sans_date > 0 && <span className="text-[#A1281D]" data-testid="bb-prev-sans-date"> · {prevision.sans_date} dossier{prevision.sans_date > 1 ? 's' : ''} actif{prevision.sans_date > 1 ? 's' : ''} sans date de signature estimée (non comptés)</span>}
          </p>
        </div>
      </div>
    </Panel>
  );
};
